<kendo-dialog [title]="title"
              [width]="760"
              [height]="620"
              (close)="onClose()">
    <div class="help-body">
        <ng-container *ngComponentOutlet="content"></ng-container>
    </div>

    <kendo-dialog-actions>
        <button kendoButton primary="true" (click)="onClose()">Okay</button>
    </kendo-dialog-actions>
</kendo-dialog>
